import { useCallback, useEffect, useState } from 'react';
import styles from './BonusCarousel.module.scss';
import { BonusCarouselItem, BonusCarouselItemType } from './components/bonusCarouselItem';
export type BonusCarouselProps = {
  listOfItem?: BonusCarouselItemType[];
  handlePromoSelected: Function;
  bonusSelected: string;
  promoHasMatched: boolean;
};

export const BonusCarousel = ({
  listOfItem,
  handlePromoSelected,
  bonusSelected,
  promoHasMatched,
}: BonusCarouselProps) => {
  const findActiveElement = useCallback(() => {
    if (promoHasMatched) {
      return listOfItem!.findIndex((elem) => elem.promoCode === bonusSelected);
    }
    return -1;
  }, [bonusSelected, listOfItem, promoHasMatched]);

  const [activeItem, setActiveItem] = useState<number | null>(findActiveElement());

  const handleCurrentBonus = (index: number, promoCode: string) => {
    if (activeItem === index) {
      handlePromoSelected('');
      return setActiveItem(null);
    }
    handlePromoSelected(promoCode);
    return setActiveItem(index);
  };

  useEffect(() => {
    setActiveItem(findActiveElement());
  }, [findActiveElement]);

  return (
    <div className={styles.container}>
      {listOfItem &&
        listOfItem.map((item: BonusCarouselItemType, index: number) => {
          return (
            <BonusCarouselItem
              key={item.typeOfBonus + '_' + index}
              id={item.id}
              typeOfBonus={item.typeOfBonus}
              text={item.text}
              bgImage={item.bgImage}
              promoCode={item.promoCode}
              informationTitle={item.informationTitle}
              informationText={item.informationText}
              index={index}
              handleCurrentBonus={handleCurrentBonus}
              activeItem={activeItem}
            />
          );
        })}
    </div>
  );
};
